import { getStore } from '../actions/storeActions';
import { useDispatch } from 'react-redux';
import PageLoader from './loader/PageLoader';
import { useNavigate } from 'react-router-dom';
import packageInfo from '../../package.json';
import { IoChevronDown } from 'react-icons/io5';
import Search from './search';
import { useState, useEffect } from 'react';
import { isAllowToChangeStore } from '../utils/Validator';

import { openCrashReportFromUtils } from '../utils/crashReportUtils';

const StoreList = ({ stores, image, name, axiosInstance }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState('');
  const [filteredStores, setFilteredStores] = useState([]);


  const handleStoreSelection = (storeId) => {
    localStorage.setItem('isCheckStore', 'true');
    localStorage.removeItem('isCheckStoreAlreadyAsk');

    dispatch(getStore(storeId, axiosInstance));
  };

  const handleBack = () => {
    const company =
      new URLSearchParams(window.location.search).get('company') || '';
    const isCompanyUndefined = !company || company === '';

    if (isCompanyUndefined || isAllowToChangeStore(company.toUpperCase())) {
      navigate('?');
    }
  };

  const handleSearch = (value) => {
    setSearchTerm(value);
  };

  // Déplacer le useEffect avant la condition
  useEffect(() => {
    if (stores) {
      const searchTermLower = searchTerm.toLowerCase();
      const filtered = stores.filter(
        (store) =>
          store.city.toLowerCase().includes(searchTermLower) ||
          (store?.address?.toLowerCase().includes(searchTermLower)),
      );
      setFilteredStores(filtered);
    }
  }, [searchTerm, stores]);

  if (!stores) {
    return <PageLoader />;
  }

  // Grouper les magasins par département
  const storesByDepartment = filteredStores.reduce((acc, store) => {
    const dept = store.city || 'Autres';
    if (!acc[dept]) {
      acc[dept] = [];
    }
    acc[dept].push(store);
    return acc;
  }, {});

  const isToolkitEnabled = process.env.REACT_APP_TOOLKIT?.toUpperCase() === 'TRUE';
  const isDevOrStageEnv = process.env.NODE_ENV === 'development' || isToolkitEnabled;

  return (
    <div className="flex flex-col h-full w-full bg-[#FFFBF1] px-4 py-6 mt-6 overflow-auto pb-24">
      {/* Bouton entreprise */}
      <div className="flex items-center justify-center w-full h-fit p-1 !rounded-2xl payer mb-6 mt-2">
        <div
          className="relative bg-white w-full !rounded-2xl border border-gray-300 p-3 flex items-center cursor-pointer hover:bg-gray-50 transition-colors"
          onClick={handleBack}
        >
          <div className="w-14 h-14 rounded-xl bg-zinc-100 p-2 flex items-center justify-center">
            <img
              src={image}
              alt={name}
              className="w-full h-full object-contain"
            />
          </div>
          <span className="ml-3 text-xl font-semibold text-gray-900">
            {name}
          </span>
          <IoChevronDown className="ml-2 text-gray-400" size={20} />
        </div>
      </div>

      {/* Barre de recherche */}
      <Search
        handleSearch={handleSearch}
        placeholder="Rechercher par ville ou adresse..."
      />

      {stores.length === 0 ? (
        <div className="flex items-center justify-center w-full min-h-24 p-1 !rounded-2xl mb-6 mt-10  bg-white border border-gray-300">
          <div className="text-xl font-bold text-gray-900">Aucun magasin trouvé pour cette enseigne</div>
        </div>
      ) : (
        <div className="space-y-6 animate-fade-in mt-6 px-6">
          {Object.entries(storesByDepartment).map(
            ([department, departmentStores]) => (
              <div key={department} className="animate-slide-in">
                <h2 className="text-xl font-bold mb-4">{department}</h2>
                <div className="space-y-3">
                  {departmentStores.map((store) => (
                    <div
                      key={store.id}
                      onClick={() => handleStoreSelection(store.id)}
                      className="bg-white !rounded-2xl border border-gray-400 p-4
                              hover:bg-gray-50 active:scale-[0.99] cursor-pointer
                              transition-all duration-200 ease-out animate-slide-in"
                    >
                      <div className="flex items-center">
                        <div className="flex-1">
                          <h3 className="text-indigo-700 bg-indigo-100 geomanistRegular w-fit p-2 rounded-lg text-xl mb-2">
                            {store.name}
                          </h3>
                          <p className="text-gray-600 mt-1 flex items-center gap-2">
                            <svg
                              className="w-5 h-5"
                              viewBox="0 0 20 20"
                              fill="currentColor"
                            >
                              <path
                                fillRule="evenodd"
                                d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z"
                                clipRule="evenodd"
                              />
                            </svg>
                            {store.address}
                          </p>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            ),
          )}
        </div>
      )}




      {/* Version */}
      <div className="fixed bottom-4 left-1/2 -translate-x-1/2 animate-fade-in">
        <span className="text-[14px] text-gray-400/60 font-light">
          v{packageInfo.version}
        </span>
      </div>

    {isDevOrStageEnv ?
      <div className="flex justify-center items-center">
        <button type="button" className="button mt-14"
          onClick={openCrashReportFromUtils}>
          Launch error crash
        </button>
      </div>
      : null}
    </div>
  );
};

export default StoreList;
